import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    // Detects if device is on iOS
    return (<div></div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js